import React, { useState } from "react";
import {
  Box,
  Card,
  CardHeader,
  CardBody,
  Text,
  Button,
  Layer,
  Heading,
} from "grommet";
import { FormUp, FormDown, Archive, Upload, FormClose } from "grommet-icons";

const getLevelText = (level) => {
  if (level === 0) return "Prerequisite";
  if (level === 1) return "Foundation";
  if (level === 2) return "Intermediate";
  return "N/A";
};

const getModeText = (isElearning) => {
  if (isElearning === 0) return "ILT/VILT";
  if (isElearning === 1) return "elearning";
  if (isElearning === 2) return "eLearning/ILT/VILT";
  return "N/A";
};

const CourseCard = ({
  course,
  index,
  total,
  onMoveUp,
  onMoveDown,
  onStatusChange,
}) => {
  const [showModal, setShowModal] = useState(false);

  const statusChanged = course.status !== course.originalStatus;
  const orderChanged = course.course_order !== course.originalOrder;
  const isModified = statusChanged || orderChanged;

  const openModal = (e) => {
    if (e.target.tagName !== "BUTTON") setShowModal(true);
  };

  return (
    <>
      <Card
        background="white"
        round="small"
        elevation="small"
        style={{
          border: isModified ? "2px solid #FFAA00" : undefined,
        }}
        maxHeight="small"
        overflow="hidden"
        gap="small"
        onClick={openModal}
      >
        <CardHeader
          pad={{ horizontal: "medium", vertical: "small" }}
          background="light-3"
          style={{ cursor: "pointer" }}
        >
          <Box
            direction="row"
            fill="horizontal"
            justify="between"
            align="center"
          >
            <Box direction="row" align="center" gap="small">
              <Text weight="bold">{index + 1}.</Text>
              <Box
                width="10px"
                height="10px"
                round="full"
                background={
                  course.status === 1 ? "status-ok" : "status-critical"
                }
              />
              <Text weight="bold">{course.courseName}</Text>
              {isModified && (
                <Box
                  background="accent-1"
                  pad={{
                    horizontal: "xsmall",
                    vertical: "xxsmall",
                  }}
                  round="small"
                >
                  <Text size="xsmall" color="status-warning">
                    Changes:{" "}
                    {statusChanged &&
                      `${
                        course.originalStatus === 1
                          ? "Published"
                          : "Unpublished"
                      } → ${course.status === 1 ? "Published" : "Unpublished"}`}
                    {statusChanged && orderChanged && " & "}
                    {orderChanged &&
                      `Course Order ${
                        course.originalOrder ?? "N/A"
                      } → ${course.course_order}`}
                  </Text>
                </Box>
              )}
            </Box>
            <Box direction="row" gap="xxsmall" align="center">
              {index > 0 && (
                <Button
                  icon={<FormUp />}
                  title="Move up"
                  onClick={(e) => {
                    e.stopPropagation();
                    onMoveUp(index);
                  }}
                />
              )}
              {index < total - 1 && (
                <Button
                  icon={<FormDown />}
                  title="Move down"
                  onClick={(e) => {
                    e.stopPropagation();
                    onMoveDown(index);
                  }}
                />
              )}
              <Button
                icon={
                  course.status === 1 ? (
                    <Archive color="status-critical" />
                  ) : (
                    <Upload color="brand" />
                  )
                }
                title={course.status === 1 ? "Unpublish" : "Publish"}
                onClick={(e) => {
                  e.stopPropagation();
                  onStatusChange(course.course_id);
                }}
              />
            </Box>
          </Box>
        </CardHeader>
      </Card>

      {showModal && (
        <Layer
          onEsc={() => setShowModal(false)}
          onClickOutside={() => setShowModal(false)}
        >
          <Box pad="medium" gap="small" width="medium">
            <Box direction="row" justify="between" align="center">
              <Heading level="3" margin="none">
                {course.courseName} – Details
              </Heading>
              <Button
                icon={<FormClose />}
                onClick={() => setShowModal(false)}
              />
            </Box>
            <CardBody pad={{ horizontal: "medium", vertical: "small" }}>
              <Box gap="xsmall">
                <Text size="small" color="dark-6">
                  Course Code: {course.c_id}
                </Text>
                <Text size="small" color="dark-6">
                  Original Order: {course.originalOrder ?? "N/A"}
                </Text>
                <Text size="small" color="dark-6">
                  Vendor: {course.OEM}
                </Text>
                <Text size="small" color="dark-6">
                  Duration: {course.duration}
                </Text>
                <Text size="small" color="dark-6">
                  Tags: {getModeText(course.isElearning)} |{" "}
                  {getLevelText(course.level)}
                </Text>
              </Box>
            </CardBody>
          </Box>
        </Layer>
      )}
    </>
  );
};

export default CourseCard;
